import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { Badge } from "../components/ui/badge";
import { costGuide } from "../mock";

export default function CostGuide() {
  return (
    <section id="costs" className="max-w-6xl mx-auto px-6 py-16">
      <div className="mb-6">
        <Badge className="bg-[hsl(22,100%,50%)]/10 text-[hsl(22,100%,40%)]">Costs (Guide)</Badge>
        <h2 className="text-2xl md:text-3xl font-bold tracking-tight mt-3">Typical London extension costs</h2>
        <p className="text-muted-foreground mt-2 max-w-prose">Every project is unique — these ranges are indicative and exclude kitchens, bathrooms and finishes unless stated.</p>
      </div>
      <div className="grid md:grid-cols-3 gap-6">
        {costGuide.map((c) => (
          <Card key={c.id} className="bg-white/70 backdrop-blur-md">
            <CardHeader>
              <CardTitle>{c.name}</CardTitle>
              <p className="text-[hsl(22,100%,40%)] font-semibold">{c.range}</p>
            </CardHeader>
            <CardContent>
              <ul className="text-sm text-muted-foreground list-disc pl-5 space-y-1">
                {c.notes.map((n, idx) => <li key={idx}>{n}</li>)}
              </ul>
            </CardContent>
          </Card>
        ))}
      </div>
      <p className="text-xs text-muted-foreground mt-4">Disclaimer: Pricing varies by design, access, structure, specification and market conditions. We’ll provide a transparent, itemised quote for your project.</p>
    </section>
  );
}